// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./decorators/toggleOpen/toggleOpen.sass
// module id = 567
// module chunks = 0